/// <amd-module name="DistributedTask/Common/Library/Sources/Queue" />
import { TaskAgentQueue, TaskAgentQueueActionFilter } from "DistributedTask/Client/Contracts/TaskAgent";
import { getTaskAgentClient, ITaskAgentRestClient } from "DistributedTask/Client/RestClient/TaskAgent";

import { IVssPageContext } from "VSS/Platform/Context";

import { IGetQueuesFilter } from "./Queue.types";

export interface IQueueSourceOptions {
    pageContext: IVssPageContext;
    project: string;
}

export class QueueSource {
    private _client: ITaskAgentRestClient;
    private _project: string;

    constructor(options: IQueueSourceOptions) {
        this._client = getTaskAgentClient(options.pageContext);
        this._project = options.project;
    }

    public getQueues(): Promise<TaskAgentQueue[]> {
        return this._getQueues({
            project: this._project
        });
    }

    private _getQueues(filter: IGetQueuesFilter) {
        return this._client.getAgentQueues(
            filter.project || this._project,
            filter.queueName || undefined,
            filter.actionFilter || TaskAgentQueueActionFilter.Use
        ).then((queues) => {
            return this._sortQueues(queues || []);
        });
    }

    private _sortQueues(queues: TaskAgentQueue[]) {
        return (queues || []).sort((a, b) => {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
    }
}
